module.exports = __webpack_public_path__ + "media/a8.95f6b331.mp3";